import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent"
import { environment } from "src/environments/environment";

if (environment?.newRelic?.isEnabled) {
    // Init global New Relic Agent for portal.
    // It will automatically detect page-level events across web application.
    new BrowserAgent(environment.newRelic.options);
}

